import { render, staticRenderFns } from "./CreditScoreDemo.vue?vue&type=template&id=70a89458&scoped=true&"
import script from "./CreditScoreDemo.vue?vue&type=script&lang=js&"
export * from "./CreditScoreDemo.vue?vue&type=script&lang=js&"
import style0 from "./CreditScoreDemo.vue?vue&type=style&index=0&id=70a89458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a89458",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VForm,
  VIcon,
  VLayout,
  VRadio,
  VRadioGroup,
  VSelect,
  VTextField,
})
